function useCalendly() {
	/**
	 * Open Calendly
	 */
	const openCalendly = () => {
		window.open(`${process.env.REACT_APP_HOST_CLIENT_SUPPORTO}`, "_blank").focus();
	};

	return { openCalendly };
}

export default useCalendly;
